import { render, staticRenderFns } from "./NotificacionesCampana.vue?vue&type=template&id=2033bb2c&scoped=true"
import script from "./NotificacionesCampana.vue?vue&type=script&lang=js"
export * from "./NotificacionesCampana.vue?vue&type=script&lang=js"
import style0 from "./NotificacionesCampana.vue?vue&type=style&index=0&id=2033bb2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2033bb2c",
  null
  
)

export default component.exports